<template>
  <nav id="mega-menu" v-click-outside="clickOutside" aria-label="secondaryNavigation">
    <div class="container">
      <template v-for="(menu, i) in menus" >
        <MenuButton 
          :key="'button' + (i+1)"
          :name="menu.name" 
          :id="'mega-menu__button' + (i+1)"
          :isActive="open === i" 
          @click.native="toggleMenu(i)"
        />
        <MenuPanel
          :key="'panel' + (i+1)"
          :name="menu.name" 
          :id="'mega-menu__panel' + (i+1)"
          :isActive="open === i" 
          :aria-labelledby="'mega-menu__button' + (i+1)"
          :lists="menu.lists"
          :promo="menu.promo"
          @close-panel="toggleMenu('')"
        />
      </template>
    </div>
    <Overlay :active="open !== ''" @click.native="toggleMenu('')"/>
  </nav>
</template>

<script>
  import MenuButton from './MenuButton.vue'
  import MenuPanel from './MenuPanel.vue'
  import Overlay from './MenuOverlay.vue'

  export default {
    name: 'MegaMenu',
    props: {
      menus: Array
    },
    data() {
      return {
        open: '',
      }
    },
    components: {
      MenuButton,
      MenuPanel,
      Overlay
    },
    methods: {
      toggleMenu(menu) {
        this.open = (this.open === menu) ? '' : menu
      },
      clickOutside() {
        this.open = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  #mega-menu {
    border-bottom: 1px solid #333;
    height: 60px;
    position: relative;
    background: #fff;

    @media (max-width: 1291px) { display: none }
  }
</style>

<style lang="scss">
  /* NON-PATTERN-CONFORMING HACKS */
  ///////////////////////////////////////////////////////////////////////////////

  /* Line Breaks "Transportation And Development" button after "Transportation" */
  #mega-menu__button6 {
    margin: 0;
    width: 168px;
  }

  /* Specific column break after Departments & Agencies List in First Panel */
  #mega-menu__panel1 .menu-panel-group:nth-child(2) {
    margin-bottom: 100px;
  }
</style>